import Main from '@/views/Main.vue';
import Login from '@/views/login/login.vue';
import Qrcode from '@/views/qrcode/qrcode.vue';
// import ForgetPassword from '@/views/login/forget.vue';
import Page404 from '@/views/error_page/404.vue';
import Page403 from '@/views/error_page/403.vue';
import Page500 from '@/views/error_page/500.vue';
import Home from '@/views/home/home.vue';
import Group from '@/views/group/group.vue';
import Layout from '@/views/layout/layout.vue';
import LayoutShop from '@/views/layoutshop/layoutshop.vue';
import OEETable from '@/views/oeetable/oeeTable.vue';
import OEETableApp from '@/views/oeetableapp/oeeTableApp.vue';
import Production from '@/views/production/production.vue';
import ProductionTarget from '@/views/production/target.vue';
import ProductionCost from '@/views/production/cost.vue';
import Users from '@/views/users/users.vue';
import Analysis from '@/views/analysis/analysis.vue';
import OeeAnls from '@/views/analysis/oeeanls.vue';
import EleAnls from '@/views/analysis/eleanls.vue';
import FinishAnls from '@/views/analysis/finishanls.vue';
import Alarm from '@/views/alarm/alarm.vue';
import System from '@/views/system/system.vue';
import FactoryManage from '@/views/system/factoryManage.vue';
import Arrange from '@/views/system/arrange.vue';
import LayoutManage from '@/views/system/layoutManage.vue';
import GroupManage from '@/views/system/groupManage.vue';
import DeviceManage from '@/views/system/deviceManage.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: 'Login - 登录'
    },
    component: Login
};

export const qrcodeRouter = {
    path: '/qrcode/:code',
    name: 'qrcode',
    meta: {
        title: 'qrcode - 验证'
    },
    component: Qrcode
};

export const oeeTableAppRouter = {
    path: '/oeetableapp/:gid/:width',
    name: 'oeetableapp',
    component: OEETableApp
};

export const page404 = {
    path: '/*',
    name: 'error-404',
    meta: {
        title: '404-页面不存在'
    },
    component: Page404,
    beforeEnter: (to, from, next) => {
        if (to.path.includes('oeetableapp')) {
            next(`${to.path}/100`);
        } else {
            next();
        }
    }
};

export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足'
    },
    name: 'error-403',
    component: Page403
};

export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: Page500
};

// 作为Main组件的子页面展示
export const appRouter = {
    path: '/',
    component: Main,
    children: [
        {
            // 首页
            path: '/',
            name: 'index',
            component: Home
        },
        {
            // 首页
            path: 'home',
            name: 'home',
            component: Home
        },
        {
            //OEE报表
            path: 'oeetable/:gid',
            name: 'oeetable',
            component: OEETable
        },
        {
            // 机组详情
            path: 'group/:gid',
            name: 'group',
            component: Group
        },
        {
            //工厂布局
            path: 'layout',
            name: 'layout',
            component: Layout
        },
        {
            //工厂布局详情页面
            path: 'layoutshop/:ws_id',
            name: 'layoutshop',
            component: LayoutShop
        },
        {
            // 生产管理
            path: 'production',
            name: 'production',
            component: Production,
            children: [
                //生产目标
                {
                    path: 'target',
                    name: 'target',
                    component: ProductionTarget
                },
                //成本分析
                {
                    path: 'cost',
                    name: 'cost',
                    component: ProductionCost
                }
            ]
        },
        {
            // 数据分析
            path: 'analysis',
            name: 'analysis',
            component: Analysis,
            children: [
                //oee分析
                {
                    path: 'oee',
                    name: 'oeeanls',
                    component: OeeAnls
                },
                //电量分析
                {
                    path: 'ele',
                    name: 'eleanls',
                    component: EleAnls
                },
                //生产数量分析
                {
                    path: 'finish',
                    name: 'finishanls',
                    component: FinishAnls
                }
            ]
        },
        {
            // 报警管理
            path: 'alarm',
            name: 'alarm',
            component: Alarm
        },
        {
            // 用户管理
            path: 'users',
            name: 'users',
            component: Users
        },
        {
            // 系统设置
            path: 'system',
            name: 'system',
            component: System,
            children: [
                // 工厂管理
                {
                    path: 'factory',
                    name: 'factoryManage',
                    component: FactoryManage
                },
                // 车间管理
                {
                    path: 'arrange',
                    name: 'arrange',
                    component: Arrange
                },
                // 车间布局
                {
                    path: 'layout',
                    name: 'layoutManage',
                    component: LayoutManage
                },
                // 车间管理
                {
                    path: 'group',
                    name: 'groupManage',
                    component: GroupManage
                },
                // 设备管理
                {
                    path: 'device',
                    name: 'deviceManage',
                    component: DeviceManage
                }
            ]
        }
    ]
};

// 所有上面定义的路由都要写在下面的routers里
export default [loginRouter, qrcodeRouter, oeeTableAppRouter, appRouter, page500, page403, page404];
//



// WEBPACK FOOTER //
// ./src/router/router.js